import qs from "query-string";
import { getBrands, getEnvs, getThemes } from "../../api";
import storage, { ACCEPTED_POPUP_KEY } from "../storage";
import { AVAILABLE_ENVS, getEnv } from "../envs";
import QUERY_PARAMS from "../../constants/queryParams";

const TOGGLE_BUILDER = "TOGGLE_BUILDER";
const TOGGLE_EDITOR = "TOGGLE_EDITOR";
const TOGGLE_POPUP = "TOGGLE_POPUP";
const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS";
const SET_ACTIVE_BRAND = "SET_ACTIVE_BRAND";
const SET_ACTIVE_BRANCH = "SET_ACTIVE_BRANCH";
const SET_ACTIVE_THEMES_BRANCH = "SET_ACTIVE_THEMES_BRANCH";
const SET_THEMES_BRANCHES = "SET_THEMES_BRANCHES";
const SET_BRANCHES = "SET_BRANCHES";
const SET_ENVS = "SET_ENVS";
const CLOSE_DEMO_POPUP = "CLOSE_DEMO_POPUP";
const SET_ROUTING = "SET_ROUTING";
const TOGGLE_BET_SLIP_OFFSET_BOTTOM = "TOGGLE_BET_SLIP_OFFSET_BOTTOM";
const SET_ACTIVE_WIDGETS_TAB = "SET_ACTIVE_WIDGETS_TAB";
const THEMES_LOADING = "THEMES_LOADING";
const THEMES_SUCCESS = "THEMES_SUCCESS";
const SET_ACTIVE_ENV = "SET_ACTIVE_ENV";

export const LOCAL_DEV_THEME = "localhost";
export const BASENAME = "basename";
export const HANDLE_PAGE_CHANGE = "handlePageChange";
export const BT_PATH = "bt-path";
export const ROUTING_OPTIONS = [BASENAME, HANDLE_PAGE_CHANGE, BT_PATH];

const state = {
  popup: {
    isPopupVisible: false,
    activePopupId: null,
  },
  envs: AVAILABLE_ENVS,
  builderVisible: false,
  editorVisible: false,
  showDemoPopup:
    !storage.getItem(ACCEPTED_POPUP_KEY) && process.env.PRESENTATION,
  showBottomPanel: storage.getItem("bet_slip_offset_bottom") === "true",
  activeWidgetsTab:
    storage.getItem("activeWidgetsTab") || "Betting tournament/Promo",
  routing: storage.getItem("bt_routing") || BASENAME,
  activeEnv: process.env.PRESENTATION ? getEnv() : null,
  brands: [],
  branches: [],
  themesBranches: [],
  isPresentation: process.env.PRESENTATION,
  selectedThemesBranch: storage.getItem("bt_themes_branch") || "master",
  selectedBranch:
    qs.parse(window.location.search)[QUERY_PARAMS.BRANCH_NAME] ||
    storage.getItem("bt_branch") ||
    "develop",
  activeBrand: process.env.PRESENTATION ? process.env.BRAND_ID : null,
  isBetbyGames: !!process.env.BETBY_GAMES,
  themesLoading: false,
  themes: [],
};

const mutations = {
  [TOGGLE_BUILDER](state) {
    state.builderVisible = !state.builderVisible;
  },
  [TOGGLE_EDITOR](state) {
    state.editorVisible = !state.editorVisible;
  },
  [TOGGLE_POPUP](state, { id }) {
    if (state.popup.isPopupVisible) {
      state.popup.activePopupId = null;
      state.popup.isPopupVisible = false;
    } else {
      state.popup.activePopupId = id;
      state.popup.isPopupVisible = true;
    }
  },
  [GET_BRANDS_SUCCESS](state, { brands }) {
    state.brands = brands;
  },
  [SET_ACTIVE_BRAND](state, { brand }) {
    state.activeBrand = brand;
  },
  [SET_ACTIVE_THEMES_BRANCH](state, { branch }) {
    state.selectedThemesBranch = branch;
  },
  [SET_ACTIVE_BRANCH](state, { branch }) {
    state.selectedBranch = branch;
  },
  [SET_THEMES_BRANCHES](state, { themesBranches }) {
    state.themesBranches = themesBranches;
    if (!state.themesBranches.includes(state.selectedThemesBranch)) {
      state.selectedThemesBranch = "master";
    }
  },
  [SET_BRANCHES](state, { branches }) {
    state.branches = branches;
    if (!state.branches.includes(state.selectedBranch)) {
      state.selectedBranch = branches[0];
    }
  },
  [SET_ENVS](state, { backend }) {
    state.envs = backend;
  },
  [CLOSE_DEMO_POPUP](state) {
    state.showDemoPopup = false;
  },
  [SET_ROUTING](state, { value }) {
    state.routing = value;
  },
  [TOGGLE_BET_SLIP_OFFSET_BOTTOM](state, { value }) {
    state.showBottomPanel = value;
  },
  [SET_ACTIVE_WIDGETS_TAB](state, { value }) {
    state.activeWidgetsTab = value;
  },
  [THEMES_LOADING](state) {
    state.themesLoading = true;
  },
  [THEMES_SUCCESS](state, { themes }) {
    state.themesLoading = false;
    state.themes = themes;
  },
  [SET_ACTIVE_ENV](state, { activeEnv }) {
    state.activeEnv = activeEnv;
  },
};

const actions = {
  toggleBuilder({ commit }) {
    commit(TOGGLE_BUILDER);
  },
  toggleEditor({ commit }) {
    commit(TOGGLE_EDITOR);
  },
  togglePopup({ commit }, id) {
    commit(TOGGLE_POPUP, { id });
  },
  setRouting({ commit }, value) {
    storage.setItem("bt_routing", value);
    commit(SET_ROUTING, { value });
  },
  toggleBetSlipOffsetBottom({ commit }, value) {
    storage.setItem("bet_slip_offset_bottom", value);
    commit(TOGGLE_BET_SLIP_OFFSET_BOTTOM, { value });
  },
  setActiveWidgetsTab({ commit }, value) {
    storage.setItem("activeWidgetsTab", value);
    commit(SET_ACTIVE_WIDGETS_TAB, { value });
  },
  getBrands({ commit }, envName) {
    getBrands(envName)
      .then((response) => {
        const savedBrandId = storage.getItem("bt_brand_id");

        const brands = response.data.items;
        const activeBrandId = brands.includes(savedBrandId)
          ? savedBrandId
          : brands[0];

        if (response.status === 200) {
          const urlBrandId = qs.parse(window.location.search)[
            QUERY_PARAMS.BRAND_ID
          ];

          commit(GET_BRANDS_SUCCESS, { brands });
          commit(SET_ACTIVE_BRAND, {
            brand: urlBrandId || activeBrandId,
          });
        }
      })
      .catch(() => {
        commit(GET_BRANDS_SUCCESS, { brands: ["1653815133341880320"] });
        commit(SET_ACTIVE_BRAND, { brand: "1653815133341880320" });
      });
  },

  setEnv({ dispatch }, env) {
    dispatch("auth/logout", null, { root: true });
    storage.setItem("bt_env", JSON.stringify(env));
    location.reload();
  },

  setBrand({ commit, dispatch }, brand) {
    dispatch("auth/logout", null, { root: true });
    storage.setItem("bt_brand_id", brand);
    location.reload();
  },
  setThemesBranch({ commit }, branch) {
    storage.setItem("bt_themes_branch", branch);
    commit(SET_ACTIVE_THEMES_BRANCH, { branch });
  },
  setBranch({ commit }, branch) {
    storage.setItem("bt_branch", branch);
    commit(SET_ACTIVE_BRANCH, { branch });
  },
  getThemes({ commit }) {
    commit(THEMES_LOADING);
    getThemes().then((themes) => commit(THEMES_SUCCESS, { themes }));
  },
  getEnvs({ commit }) {
    getEnvs()
      .then(({ frontend, backend, themesBranches }) => {
        // accepted names: feature-name, feature/name, release-name,
        // release/name, hotfix-name, hotfix/name, develop, master, beta
        const branches = [
          "develop",
          "beta",
          "master",
          ...frontend
            .filter((b) => /^((feature|release|hotfix)-.+)/.test(b))
            .map((b) => b.toLowerCase()),
        ];
        const environmentNameQueryParam = qs.parse(window.location.search)[
          QUERY_PARAMS.ENVIRONMENT_NAME
        ];
        const activeEnv = environmentNameQueryParam
          ? backend.find((i) => i.name === environmentNameQueryParam) ||
            getEnv()
          : getEnv();

        commit(SET_ACTIVE_ENV, { activeEnv });
        commit(SET_THEMES_BRANCHES, {
          themesBranches: [
            "master",
            "beta",
            window.location.hostname === "localhost" && LOCAL_DEV_THEME,
            ...themesBranches.filter((b) =>
              /^((feature|release|hotfix)-.+)/.test(b)
            ),
          ].filter(Boolean),
        });
        commit(SET_BRANCHES, { branches });
        commit(SET_ENVS, { backend });
      })
      .catch(() => {
        commit(SET_THEMES_BRANCHES, { themesBranches: [] });
        commit(SET_BRANCHES, { branches: [] });
      });
  },
  closeDemoPopup({ commit }) {
    storage.setItem(ACCEPTED_POPUP_KEY, Date.now().toString());
    commit(CLOSE_DEMO_POPUP);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
